module.exports = __webpack_public_path__ + "img/e15cb5e.png";